import _asyncToGenerator from "/var/www/verifynest/resources/assets/js/qportal/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/var/www/verifynest/resources/assets/js/qportal/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Http from '@/services/Http';
import Auth from '@/services/Auth';
import cssVars from 'css-vars-ponyfill';
import Qdebug from '@/mixins/Qdebug';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var app, store, Vue, client, common, user;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            app = _ref.app, store = _ref.store, Vue = _ref.Vue;
            Vue.mixin(Qdebug);
            client = Http.client();
            _context.next = 5;
            return client.get('/common');

          case 5:
            common = _context.sent;
            store.dispatch('common/setCommonData', common.data); // user data

            _context.prev = 7;
            _context.next = 10;
            return client.get('/auth/check');

          case 10:
            user = _context.sent;
            store.dispatch('user/setUserData', user.data);
            Auth.login();
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](7);
            Auth.logout();

          case 18:
            // set variables
            cssVars({
              variables: {// '--q-color-primary': branding.data.colours.primary,
                // '--q-color-secondary': branding.data.colours.secondary,
                // '--q-color-positive': branding.data.colours.positive,
                // '--q-color-negative': branding.data.colours.negative,
                // '--q-color-accent': branding.data.colours.accent,
                // '--q-color-info': branding.data.colours.info,
                // '--q-color-warning': branding.data.colours.warning
              },
              rootElement: document
            });

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 15]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();